export const OK_CODE = 200
export const INTERNAL_SERVER_ERROR = 500
export const UNAUTHORIZED = 401
export const NOT_FOUND = 404
export const BAD_REQUEST = 400
export const FORBIDDEN = 403
